module.exports = __webpack_public_path__ + "img/boold.8a50a926.webp";